

export const AreHTMLInstructions = {
    AddElement: '_AreHTML_AddElement',
    AddText: '_AreHTML_AddText',
    AddAttribute: '_AreHTML_AddAttribute',
    AddStyle: '_AreHTML_AddStyle',
    AddListener: '_AreHTML_AddListener',
    AddInterpolation: '_AreHTML_AddInterpolation',
    AddComment: '_AreHTML_AddComment',
    AddStaticHTML: '_AreHTML_AddStaticHTML',
    HideElement: '_AreHTML_HideElement',
} as const